<template>
  <el-dialog title="编辑JSON数据" :visible.sync="dialogVisible" width="1200px" @close="handleClose">
    <div class="json-editor-container">
      <!-- JSON预览区域 -->
      <div class="json-preview">
        <h4>JSON 预览</h4>
        <el-input
          type="textarea"
          v-model="jsonString"
          :rows="20"
          placeholder="请输入JSON字符串"
          class="json-textarea"
        />
      </div>
      
      <!-- JSON编辑表单 -->
      <div class="json-form">
        <h4>编辑JSON字段：</h4>
        <el-form :model="jsonForm" ref="jsonForm" label-width="150px">
          <json-field-editor 
            v-model="jsonForm" 
            :path="[]"
            @update="updateJsonField"
            @delete="deleteJsonField" />
        </el-form>
        

      </div>
    </div>
    
    <div slot="footer" class="dialog-footer">
      <div class="save-options">
        <el-radio-group v-model="saveSource" size="small">
          <el-radio label="left">存储[左侧]</el-radio>
          <el-radio label="right">存储[右侧]</el-radio>
        </el-radio-group>
      </div>
      <div class="dialog-buttons">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

// 递归JSON字段编辑器组件
const JsonFieldEditor = {
  name: 'JsonFieldEditor',
  props: {
    value: {
      type: [Object, Array],
      default: () => ({})
    },
    path: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newField: {
        key: '',
        type: 'string',
        value: ''
      }
    }
  },
  computed: {
    isArray() {
      return Array.isArray(this.value)
    }
  },
  beforeDestroy() {
    // 清理递归组件状态，避免循环引用
    this.newField = {
      key: '',
      type: 'string',
      value: ''
    }
  },
  methods: {
    getFieldType(value) {
      if (typeof value === 'string') return 'string'
      if (typeof value === 'number') return 'number'
      if (typeof value === 'boolean') return 'boolean'
      if (Array.isArray(value)) return 'array'
      if (typeof value === 'object' && value !== null) return 'object'
      return 'string'
    },
    
    updateField(key, newValue) {
      const updatedValue = this.isArray ? [...this.value] : { ...this.value }
      updatedValue[key] = newValue
      this.$emit('input', updatedValue)
    },
    

    
    getFieldPath(key) {
      return [...this.path, key]
    }
  },
  render(h) {
    const renderSimpleField = (key, value) => {
      const fieldType = this.getFieldType(value)
      
      if (fieldType === 'string') {
        return h('el-input', {
          props: {
            value: value,
            size: 'small'
          },
          on: {
            input: (val) => this.updateField(key, val)
          }
        })
      } else if (fieldType === 'number') {
        return h('el-input', {
          props: {
            value: String(value),
            size: 'small',
            type: 'text'
          },
          style: {
            width: '100%'
          },
          on: {
            input: (val) => {
              const numVal = Number(val)
              this.updateField(key, isNaN(numVal) ? val : numVal)
            }
          }
        })
      } else if (fieldType === 'boolean') {
          return h('el-select', {
            props: {
              value: value,
              size: 'small'
            },
            on: {
              input: (val) => this.updateField(key, val)
            }
          }, [
            h('el-option', {
              props: {
                label: 'true',
                value: true
              }
            }),
            h('el-option', {
              props: {
                label: 'false',
                value: false
              }
            })
          ])
      }
    }
    
    if (this.isArray) {
      // 检查数组元素类型
      const firstItem = this.value[0]
      const isObjectArray = firstItem && typeof firstItem === 'object' && !Array.isArray(firstItem)
      const isSimpleArray = firstItem && (typeof firstItem === 'string' || typeof firstItem === 'number' || typeof firstItem === 'boolean')
      
      if (isSimpleArray) {
        // 简单数组：横向排列
        return h('div', { class: 'json-field-editor' }, [
          h('div', { 
            class: 'array-container',
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              alignItems: 'center',
              border: '1px solid #ddd',
              borderRadius: '4px',
              padding: '8px'
            }
          }, [
            ...this.value.map((item, index) => {
              return h('div', { 
                key: index,
                style: {
                  display: 'inline-block'
                }
              }, [
                renderSimpleField(index, item)
              ])
            })
          ])
        ])
      } else if (isObjectArray) {
         // 对象数组：每个子元素为label+input形式
         return h('div', { class: 'json-field-editor' }, [
           h('div', {
             style: {
               marginBottom: '8px'
             }
           }, [
             h('label', {
               style: {
                 fontSize: '14px',
                 fontWeight: '600',
                 color: '#2c3e50',
                 display: 'block',
                 marginBottom: '8px'
               }
             }, `${this.keyName || 'Array'} (${this.value.length} 项)`)
           ]),
           h('div', { 
             class: 'array-container',
             style: {
               display: 'grid',
               gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
               gap: '16px',
               border: '2px solid #e8f4fd',
               borderRadius: '8px',
               padding: '16px',
               backgroundColor: '#f8fbff'
             }
           }, [
             ...this.value.map((item, index) => {
               return h('div', { 
                 key: index,
                 class: 'object-item',
                 style: {
                   border: '1px solid #d1ecf1',
                   borderRadius: '8px',
                   padding: '16px',
                   backgroundColor: '#ffffff',
                   boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                   transition: 'all 0.2s ease'
                 }
               }, [
                 h('div', { 
                   style: { 
                     fontWeight: '600', 
                     marginBottom: '12px', 
                     fontSize: '13px',
                     color: '#495057',
                     borderBottom: '1px solid #e9ecef',
                     paddingBottom: '6px'
                   } 
                 }, `项目 ${index + 1}`),
                 ...Object.keys(item).map(objKey => {
                   return h('div', {
                     key: objKey,
                     style: {
                       display: 'flex',
                       alignItems: 'center',
                       marginBottom: '8px',
                       gap: '10px'
                     }
                   }, [
                     h('label', {
                       style: {
                         fontSize: '12px',
                         minWidth: '80px',
                         color: '#6c757d',
                         fontWeight: '500'
                       }
                     }, objKey + ':'),
                     h('div', { style: { flex: 1 } }, [
                       renderSimpleField(`${index}.${objKey}`, item[objKey])
                     ])
                   ])
                 })
               ])
             })
           ])
         ])
      } else {
        // 复杂数组：使用原有逻辑
        return h('div', { class: 'json-field-editor' }, [
          h('div', { 
            class: 'array-container',
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              alignItems: 'flex-start'
            }
          }, [
            ...this.value.map((item, index) => {
              return h('div', { 
                class: 'array-item', 
                key: index,
                style: {
                  flex: '0 0 auto',
                  minWidth: '200px',
                  maxWidth: '300px'
                }
              }, [
                h('div', { class: 'field-header' }, [
                  h('span', { class: 'field-label' }, `项目 ${index + 1}`)
                ]),
                h('div', { class: 'field-content' }, [
                  h(JsonFieldEditor, {
                     props: {
                       value: item,
                       path: `${this.path}[${index}]`,
                       keyName: `项目${index + 1}`
                     },
                     on: {
                       'update-field': this.updateJsonField
                     }
                   })
                ])
              ])
            })
          ])
        ])
      }
    } else {
      return h('div', { class: 'json-field-editor' }, [
        h('div', { class: 'object-container' }, [
          ...Object.keys(this.value).map(fieldKey => {
            const fieldValue = this.value[fieldKey]
            const fieldType = this.getFieldType(fieldValue)
            
            if (fieldType === 'string' || fieldType === 'number' || fieldType === 'boolean') {
              // 简单类型：label + input
              return h('div', { 
                class: 'simple-field', 
                key: fieldKey,
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px',
                  gap: '12px'
                }
              }, [
                h('label', {
                  style: {
                    minWidth: '100px',
                    fontSize: '13px',
                    fontWeight: '500'
                  }
                }, fieldKey + ':'),
                h('div', { style: { flex: 1 } }, [
                  renderSimpleField(fieldKey, fieldValue)
                ])
              ])
            } else {
              // 复杂类型：使用原有逻辑
              return h('div', { class: 'object-field', key: fieldKey }, [
                h('div', { class: 'field-header' }, [
                  h('span', { class: 'field-label' }, fieldKey)
                ]),
                h('div', { class: 'field-content' }, [
                  h(JsonFieldEditor, {
                     props: {
                       value: fieldValue,
                       path: this.getFieldPath(fieldKey),
                       keyName: fieldKey
                     },
                     on: {
                       'update-field': this.updateJsonField
                     }
                   })
                ])
              ])
            }
          })
        ])
      ])
    }
  }
}

export default {
  name: 'JsonEditDialog',
  components: {
    JsonFieldEditor
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    jsonData: {
      type: Object,
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      jsonForm: {},
      originalJson: {},
      jsonString: '',
      saveSource: 'right' // 默认存储右侧
    }
  },
  computed: {
    formattedJson() {
      return JSON.stringify(this.jsonForm, null, 2)
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    },
    jsonData: {
      handler(newData) {
        this.initJsonForm(newData)
      },
      deep: true,
      immediate: true
    },
    jsonForm: {
      handler(newVal) {
        this.jsonString = JSON.stringify(newVal, null, 2)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initJsonForm(data) {
      try {
        if (typeof data === 'string') {
          this.originalJson = JSON.parse(data)
        } else {
          this.originalJson = data || {}
        }
        this.jsonForm = JSON.parse(JSON.stringify(this.originalJson))
      } catch (error) {
        console.error('JSON解析失败:', error)
        this.originalJson = {}
        this.jsonForm = {}
        this.$message.error('JSON数据格式错误')
      }
    },
    
    getFieldType(value) {
      if (typeof value === 'string') return 'string'
      if (typeof value === 'number') return 'number'
      if (typeof value === 'boolean') return 'boolean'
      return 'object'
    },
    

    
    updateJsonField(path, value) {
      // 更新嵌套字段的值
      let target = this.jsonForm
      for (let i = 0; i < path.length - 1; i++) {
        target = target[path[i]]
      }
      if (path.length > 0) {
        this.$set(target, path[path.length - 1], value)
      }
    },
    
    deleteJsonField(path) {
      // 删除嵌套字段
      let target = this.jsonForm
      for (let i = 0; i < path.length - 1; i++) {
        target = target[path[i]]
      }
      if (path.length > 0) {
        this.$delete(target, path[path.length - 1])
      }
    },
    
    async handleSubmit() {
      this.loading = true
      try {
        let dataToSave
        
        if (this.saveSource === 'left') {
          // 保存左侧JSON字符串数据
          try {
            dataToSave = JSON.parse(this.jsonString)
          } catch (e) {
            this.$message.error('左侧JSON格式错误，请检查')
            this.loading = false
            return
          }
        } else {
          // 保存右侧表单数据
          dataToSave = this.jsonForm
        }
        
        // 调用API接口
        const response = await axios.post(this.base_url + '/orders/update_source_data', {
          id: this.orderId,
          source_data: JSON.stringify(dataToSave)
        })
        
        if (response.status === 200 && response.data.code) {
          this.$emit('save', dataToSave)
          this.$message.success('JSON数据更新成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(response.data.message || '更新失败')
        }
      } catch (error) {
        console.error('更新JSON数据失败:', error) 
      } finally {
        this.loading = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    
    resetForm() {
      this.jsonForm = JSON.parse(JSON.stringify(this.originalJson))
      this.newField = {
        key: '',
        type: 'string',
        value: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.json-editor-container {
  display: flex;
  gap: 20px;
  max-height: 650px;
  
  .json-preview {
    flex: 0 0 30%;
    max-width: 30%;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 4px;
    
    h4 {
      margin-bottom: 8px;
      color: #333;
      font-size: 14px;
    }
    
    .json-display {
      background: #f8f9fa;
      border: 1px solid #e9ecef;
      border-radius: 4px;
      padding: 12px;
      max-height: 550px;
      overflow-y: auto;
      font-family: 'Courier New', monospace;
      font-size: 11px;
      line-height: 1.4;
      white-space: pre-wrap;
      word-wrap: break-word;
      text-align: left;
      max-width: 100%;
      overflow-x: hidden;
    }
  }
  
  .json-form {
    flex: 1;
    padding: 15px;
    background-color: #fafbfc;
    border-radius: 6px;
    
    h4 {
      margin-bottom: 10px;
      color: #333;
      font-size: 14px;
    }
  }
}

.json-field-editor {
  .array-container {
    border: 1px solid #e9ecef;
    border-radius: 3px;
    padding: 8px;
    margin-bottom: 8px;
    background: #f8f9fa;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;
  }
  
  .object-container {
    border: 1px solid #e9ecef;
    border-radius: 3px;
    padding: 8px;
    margin-bottom: 8px;
    background: #f8f9fa;
  }
  
  .array-item {
    margin-bottom: 0;
    padding: 6px;
    border: 1px solid #dee2e6;
    border-radius: 3px;
    background: white;
    flex: 0 0 auto;
    min-width: 200px;
    max-width: 300px;
    
    .field-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 4px;
      
      .field-label {
        font-weight: 500;
        color: #495057;
        font-size: 12px;
        min-width: 80px;
        text-align: left;
      }
    }
    
    .field-content {
      margin-left: 0;
      
      .el-input, .el-input-number {
        width: 100%;
      }
    }
  }
  
  .object-field {
    margin-bottom: 8px;
    padding: 6px;
    border: 1px solid #dee2e6;
    border-radius: 3px;
    background: white;
    
    .field-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 4px;
      
      .field-label {
        font-weight: 500;
        color: #495057;
        font-size: 12px;
        min-width: 80px;
        text-align: left;
      }
    }
    
    .field-content {
      margin-left: 0;
      
      .el-input, .el-input-number {
        width: 100%;
      }
    }
  }
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .save-options {
    flex: 1;
  }
  
  .dialog-buttons {
    flex: 0 0 auto;
  }
  
  .json-textarea {
    font-family: 'Courier New', monospace;
    font-size: 12px;
  }
  
  .json-textarea .el-textarea__inner {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.4;
  }

.el-form {
  max-height: 500px;
  overflow-y: auto;
  
  .el-select {
    width: 100%;
  }
  
  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>